import { gql } from '@apollo/client';

// In-app AI assistant sidebar. Types are hand-written in
// src/lib/ai-assistant/types.ts: production introspection is off.

export const GENERATE_MY_AI_ASSISTANT_SUGGESTIONS = gql`
  mutation GenerateMyAiAssistantSuggestions(
    $sessionId: String!, $path: String, $clientContext: JSON, $locale: String, $previous: [String!]
  ) {
    generateMyAiAssistantSuggestions(
      sessionId: $sessionId, path: $path, clientContext: $clientContext, locale: $locale, previous: $previous
    )
  }
`;

const CONVERSATION_FIELDS = `
  id
  title
  status
  error
  updated_at
  pending_client_calls { id tool_name args }
  messages {
    id
    role
    text
    tool_name
    tool_title
    tool_status
    action { id tool_name title args status preview { kind title subtitle image_url } }
    effects { type path }
    attachments { kind url name }
    created_at
  }
`;

export const MY_AI_ASSISTANT_CONVERSATIONS = gql`
  query MyAiAssistantConversations($limit: Int) {
    myAiAssistantConversations(limit: $limit) {
      id
      title
      updated_at
    }
  }
`;

export const MY_AI_ASSISTANT_CONVERSATION = gql`
  query MyAiAssistantConversation($id: ID!) {
    myAiAssistantConversation(id: $id) {
      ${CONVERSATION_FIELDS}
    }
  }
`;

export const SEND_AI_ASSISTANT_MESSAGE = gql`
  mutation SendAiAssistantMessage(
    $conversationId: ID
    $text: String!
    $path: String
    $clientContext: JSON
    $attachments: [AssistantAttachmentInput!]
  ) {
    sendAiAssistantMessage(
      conversationId: $conversationId
      text: $text
      path: $path
      clientContext: $clientContext
      attachments: $attachments
    ) {
      ${CONVERSATION_FIELDS}
    }
  }
`;

export const SUBMIT_AI_ASSISTANT_CLIENT_RESULTS = gql`
  mutation SubmitAiAssistantClientResults(
    $conversationId: ID!
    $results: [AssistantClientResultInput!]!
    $clientContext: JSON
  ) {
    submitAiAssistantClientResults(
      conversationId: $conversationId
      results: $results
      clientContext: $clientContext
    ) {
      ${CONVERSATION_FIELDS}
    }
  }
`;

export const RESOLVE_AI_ASSISTANT_ACTION = gql`
  mutation ResolveAiAssistantAction(
    $conversationId: ID!
    $actionId: ID!
    $approve: Boolean!
    $path: String
  ) {
    resolveAiAssistantAction(
      conversationId: $conversationId
      actionId: $actionId
      approve: $approve
      path: $path
    ) {
      ${CONVERSATION_FIELDS}
    }
  }
`;

export const DELETE_MY_AI_ASSISTANT_CONVERSATION = gql`
  mutation DeleteMyAiAssistantConversation($id: ID!) {
    deleteMyAiAssistantConversation(id: $id)
  }
`;

export const ADMIN_SET_AI_ASSISTANT_ACCESS = gql`
  mutation AdminSetAiAssistantAccess($userId: ID!, $enabled: Boolean!) {
    adminSetAiAssistantAccess(userId: $userId, enabled: $enabled)
  }
`;

export const STOP_AI_ASSISTANT_TURN = gql`
  mutation StopAiAssistantTurn($conversationId: ID!) {
    stopAiAssistantTurn(conversationId: $conversationId) {
      ${CONVERSATION_FIELDS}
    }
  }
`;

export const ADMIN_AI_ASSISTANT_USAGE = gql`
  query AdminAiAssistantUsage(
    $from: String, $to: String, $search: String, $sort: String, $direction: String, $page: Int, $pageSize: Int
  ) {
    adminAiAssistantUsage(
      from: $from, to: $to, search: $search, sort: $sort, direction: $direction, page: $page, pageSize: $pageSize
    ) {
      from
      to
      totals {
        active_users messages model_calls failed_calls unpriced_calls
        prompt_tokens completion_tokens cached_tokens cost_usd
      }
      by_model {
        llm_model purpose model_calls failed_calls unpriced_calls prompt_tokens completion_tokens cost_usd
      }
      by_day { day messages model_calls cost_usd }
      rows {
        user { id name email }
        plan_name is_paid messages model_calls prompt_tokens completion_tokens cached_tokens cost_usd last_used_at
      }
      total_rows
    }
  }
`;
